/**
 * tasksense-scheduler-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How a recurring schedule resumes after a missed window or suspension.
 */
export const ContinuationMode = {
    Strict: 'STRICT',
    Continuous: 'CONTINUOUS'
} as const;
export type ContinuationMode = typeof ContinuationMode[keyof typeof ContinuationMode];

